import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";
import { YearContext } from "../../contexts/yearContext";

import MainTitle from "../common/MainTitle";
import MainButton from "../common/MainButton";
import ListStats from "../common/ListStats";
import TableMainSearch from "../common/MainSearch";
import FacultiesResultList from "./FacultiesResultList";

import lbl from "../../data/Labels.json";

const ResultFaculties = (props) => {
  const [data, setData] = useState([]);
  const { entryYear } = useContext(YearContext);
  const [query, setQuery] = useState("");

  useEffect(async () => {
    const ac = new AbortController();
    requestData({ entry_year_id: entryYear });
    return () => ac.abort();
  }, [entryYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { fid } = props.match.params;
      const { entry_year_id } = p;

      let query = `results/${fid}?`;

      if (entry_year_id) query += `&entryYearId=${entry_year_id}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content"></div>
      </div>
      <div className="main-content-body">
        <ListStats stats={data.summary} />
        <FacultiesResultList data={data.data} query={query} />
      </div>
    </div>
  );
};

export default ResultFaculties;
